// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"923":"46d045c0","998":"46d045c0"}[chunkId] + ".chunk.css";
};